import { render, staticRenderFns } from "./MyCard.vue?vue&type=template&id=69468b50&scoped=true"
import script from "./MyCard.vue?vue&type=script&lang=js"
export * from "./MyCard.vue?vue&type=script&lang=js"
import style0 from "./MyCard.vue?vue&type=style&index=0&id=69468b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69468b50",
  null
  
)

export default component.exports